import { useState, useEffect } from "react";
import "../CSS/Music.css";

function Music({
  bands,
  futureShows,
  pastShows,
  pastVenueShows,
  sanityLoaded,
}) {
  // Normalize band names for dedup: lowercase, strip punctuation, collapse whitespace
  const normalizeName = (n) =>
    n.toLowerCase().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, " ").trim();

  // Merge Sanity bands with performers from event sheets
  const allBands = (() => {
    const seen = new Set(bands.map((b) => normalizeName(b.name)));
    const allShows = [
      ...(futureShows || []),
      ...(pastShows || []),
      ...(pastVenueShows || []),
    ];
    const extra = [];
    allShows.forEach((show) => {
      show.performers.forEach((name) => {
        const key = normalizeName(name);
        if (!seen.has(key)) {
          seen.add(key);
          extra.push({
            _id: `event-${name}`,
            name,
            description: `https://duckduckgo.com/?q=${encodeURIComponent(name + " band")}`,
          });
        }
      });
    });
    return [...bands, ...extra];
  })();

  const [pageBands, setPageBands] = useState(allBands);
  const [search, setSearch] = useState("");
  const [sortDir, setSortDir] = useState("asc");
  const [view, setView] = useState("grid");

  useEffect(() => {
    setPageBands(allBands);
  }, [bands, futureShows, pastShows, pastVenueShows]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let result = allBands.filter((band) =>
      band.name.toLowerCase().includes(search.toLowerCase()),
    );
    setPageBands(result);
  }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleSearch(e) {
    setSearch(e.target.value);
  }

  function randomBand() {
    const realBands = allBands.filter(
      (b) => b.description && !b.description.includes("duckduckgo"),
    );
    if (realBands.length === 0) return null;
    return realBands[Math.floor(Math.random() * realBands.length)].description;
  }

  const sorted = [...pageBands].sort((a, b) => {
    const cmp = a.name.localeCompare(b.name);
    return sortDir === "asc" ? cmp : -cmp;
  });

  return (
    <main id="music-main">
      <div id="music-top">
        <h1>~ All of the bands ~</h1>
        <div id="music-body">
          <h3>
            These are all of the bands that have played a show at Woodland since
            2006.
          </h3>
          <h3>Click on a band to check out their tunes!</h3>
          <p style={{ color: "rgb(100,100,100)", marginTop: "4px" }}>
            {allBands.length} bands
          </p>
        </div>
        <div id="music-controls">
          <input
            placeholder="Search"
            onChange={handleSearch}
            value={search}
            type="text"
            name="search"
          />
          <div id="music-sort-view">
            <button
              className={`music-toggle-btn${sortDir === "asc" ? " active" : ""}`}
              onClick={() => setSortDir("asc")}
            >
              A → Z
            </button>
            <button
              className={`music-toggle-btn${sortDir === "desc" ? " active" : ""}`}
              onClick={() => setSortDir("desc")}
            >
              Z → A
            </button>
            <button
              className={`music-toggle-btn${view === "grid" ? " active" : ""}`}
              onClick={() => setView("grid")}
              aria-label="Grid view"
            >
              ⊞
            </button>
            <button
              className={`music-toggle-btn${view === "list" ? " active" : ""}`}
              onClick={() => setView("list")}
              aria-label="List view"
            >
              ☰
            </button>
            <a
              id="random-band"
              className="blue"
              href="#"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                const url = randomBand();
                console.log('Random band URL:', url, '| Real bands count:', allBands.filter(b => b.description && !b.description.includes('duckduckgo')).length);
                if (url) window.open(url, '_blank');
              }}
            >
              Random Band
            </a>
          </div>
        </div>
      </div>

      <div id="all-of-the-bands" className={view === "list" ? "list-view" : ""}>
        {sorted.map((band) => (
          <a
            className="band-link music-band"
            href={band.description}
            key={band._id}
            target="_blank"
            rel="noopener noreferrer"
          >
            <h4>{band.name}</h4>
            {view === "list" && band.description && (
              <span className="band-url">
                {band._id.startsWith("event-")
                  ? "search →"
                  : band.description.replace(/^https?:\/\//, "")}
              </span>
            )}
          </a>
        ))}
      </div>
    </main>
  );
}

export default Music;
